import { getCouponRedeemType, normalizeCouponCode } from "./couponHelpers";

export function buildGamePathFromDisplayName(displayName) {
  return (
    "/" +
    String(displayName || "")
      .toLowerCase()
      .replace(/[^a-z0-9/]+/g, "-")
      .replace(/(^-|-$)/g, "")
  );
}

export function getFreeSpinDetailsFromCoupon(coupon) {
  if (!coupon) return null;

  const details =
    coupon.free_spin_details ||
    coupon.freeSpinDetails ||
    coupon.raw?.free_spin_details ||
    coupon.raw?.freeSpinDetails ||
    null;

  if (!details || typeof details !== "object") return null;

  const gameId =
    details.game_id ??
    details.gameId ??
    details.GameId ??
    details.Gameid ??
    null;
  const machineId =
    details.mach_id ??
    details.machId ??
    details.machineId ??
    details.MachineId ??
    details.Machid ??
    null;
  const displayName =
    details.game_description ||
    details.gameDescription ||
    details.GameDescription ||
    details.displayName ||
    "";

  if (gameId == null || machineId == null || !String(displayName).trim()) {
    return null;
  }

  return {
    gameId,
    machineId,
    displayName: String(displayName).trim(),
    details,
  };
}

export function mapActiveCouponToFreeSpinGame(activeCoupon, games = []) {
  if (!activeCoupon) return null;
  if (getCouponRedeemType(activeCoupon) !== 3) return null;

  const spinsRemaining = Number(
    activeCoupon.spins_remaining ??
      activeCoupon.spinsRemaining ??
      activeCoupon.SpinsRemaining ??
      0,
  );
  const completed =
    activeCoupon.free_spins_completed === true ||
    activeCoupon.freeSpinsCompleted === true;

  if (completed || !(spinsRemaining > 0)) return null;

  const mapped = getFreeSpinDetailsFromCoupon(activeCoupon);
  if (!mapped) return null;

  const catalogMatch = (Array.isArray(games) ? games : []).find(
    (game) =>
      String(game?.gameId) === String(mapped.gameId) &&
      String(game?.machineId) === String(mapped.machineId),
  );

  return {
    gameId: mapped.gameId,
    machineId: mapped.machineId,
    displayName: mapped.displayName,
    remainingSpins: spinsRemaining,
    gameImageUrl:
      catalogMatch?.gameImageUrl ||
      catalogMatch?.promoImageUrl ||
      mapped.details?.game_image_url ||
      mapped.details?.gameImageUrl ||
      "",
    couponCode: normalizeCouponCode(
      activeCoupon.coupon_code || activeCoupon.couponCode,
    ),
  };
}

export function canOpenFreeSpinModal(freeSpinGame) {
  if (!freeSpinGame) return false;
  const spins = Number(freeSpinGame.remainingSpins);
  return (
    Number.isFinite(spins) &&
    spins > 0 &&
    freeSpinGame.gameId != null &&
    freeSpinGame.machineId != null &&
    Boolean(String(freeSpinGame.displayName || "").trim())
  );
}
